import Api from "../api";
import qs from "qs";
import { PaginationRequestType } from "@/entity/common/pagination.types";
import { ResponseDataType } from "@/form/form.types";
import { IServiceCosmetologistsRepository } from "./ServiceCosmetologistsRepository.types";
import { IServiceCosmetologists, IServiceCosmetologistsListItem, ServiceCosmetologistsResponseType, ServiceCosmetologistsListItemResponseType } from "@/entity/serviceCosmetologists/serviceCosmetologists.types";

import ServiceCosmetologists from "@/entity/serviceCosmetologists/serviceCosmetologists";
import { ServiceCosmetologistRequestType } from "@/form/serviceCosmetologist/serviceCosmetologist.types";

export class ServiceCosmetologistsRepository implements IServiceCosmetologistsRepository{

    async fetchAll(data?: FormData): Promise<IServiceCosmetologists>{

        const response = await Api.get('/service_cosmetologists/get', {
            params: data,
            paramsSerializer: function paramsSerializer(params) {
                return new URLSearchParams(params).toString()
        }});

        const responseData = response.data as ServiceCosmetologistsResponseType;

        return new ServiceCosmetologists(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<IServiceCosmetologistsListItem> {

        const response = await Api.get(`/service_cosmetologists/get`, {
            params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});

        const responseData = response.data as ServiceCosmetologistsResponseType;

        return new ServiceCosmetologists(responseData).data[0];
    }

    async create(data: ServiceCosmetologistRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service_cosmetologists/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async update(data: ServiceCosmetologistRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/service_cosmetologists/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: {cosmetologist_id: number, service_id: number}): Promise<ResponseDataType> {
        const response = await Api.post(`/service_cosmetologists/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}